export default {
  darkBlue: '#294E71',
  lightBlue: '#8A9EB1',
  gray: '#8A8A8A',
  white: '#FFFFFF',
  red: '#DB3428',
  gold: '#97896A',
};